module.exports = __webpack_public_path__ + "static/media/Video_caption_1.e1d62a59.png";